import { defineMessages } from 'react-intl'


export default defineMessages({
  description: {
    id: 'not-available-on-plan.description',
    defaultMessage: 'This feature isn’t included in your current plan.',
  },
  title: {
    id: 'not-available-on-plan.title',
    defaultMessage: 'Not Available on Your Plan',
  },
})
